import React, { useCallback, useContext, useState } from 'react';
import './style.css';
import { LabelForm } from '../../LabelForm';
import InputMask from 'react-input-mask';
import { useForm } from 'react-hook-form';
import { Button } from '../../Button';
import { Capitalize, FormataValor, isObjectEmpty, ValidarCPF } from '../../../utils/utils';
import { SalvarCartao } from '../../../utils/api/api';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../../contexts/HomeContext';
import P from 'prop-types';
import { Modal } from '../../Modal';
import GatewaysLogo from '../../../img/Gateways/GatewaysLogo';

export const CadastroCartoes = ({
  handleNewBack,
  setDadosCartao,
  formDireto = true,
  onClick,
  isCompleted = true,
  valor = 0,
}) => {
  const { dadosApp, user, enderecos } = useContext(GlobalContext);
  const [enderecoFatura, setEnderecoFatura] = useState(enderecos.length == 1 ? enderecos[0] : {});
  const [modalMeusDados, setModalMeusDados] = useState('none');
  const [modalEnderecos, setModalEnderecos] = useState('none');
  const [modalLoading, setModalLoading] = useState('none');
  const [creditCardMask, setCreditCardMask] = useState('9999 9999 9999 9999');
  const [isAmex, setIsAmex] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange' });

  const showHideModalLoading = useCallback(() => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  }, [modalLoading]);

  const showHideModalEnderecos = useCallback(() => {
    setModalEnderecos(modalEnderecos == 'none' ? 'block' : 'none');
  }, [modalEnderecos]);

  const showHideModalMeusDados = useCallback(() => {
    setModalMeusDados(modalMeusDados === 'none' ? 'block' : 'none');
  }, [modalMeusDados]);

  const enderecoConcatenado = () => {
    if (enderecoFatura.endereco_complemento != '') {
      return Capitalize(
        enderecoFatura.endereco + ', ' + enderecoFatura.endereco_numero + ', ' + enderecoFatura.endereco_complemento,
      );
    } else {
      return Capitalize(enderecoFatura.endereco + ', ' + enderecoFatura.endereco_numero);
    }
  };

  const handleInputs = (event) => {
    if (event.target.name == 'numeroCartao') {
      // muda a mascara caso seja Amex, quando inicia 34 ou 37
      if (/^3[47]/.test(event.target.value)) {
        setCreditCardMask('9999 999999 99999');
        setIsAmex(true);
      } else {
        if (creditCardMask != '9999 9999 9999 9999') {
          setCreditCardMask('9999 9999 9999 9999');
          setIsAmex(false);
        }
      }
    }
  };

  const removeMask = (el) => {
    let element = el;
    for (let index = 0; index < el.length; index++) {
      element = element.replace('-', '');
      element = element.replace('_', '');
      element = element.replace('/', '');
      element = element.replace(' ', '');
    }
    return element;
  };

  const handleValidade = (validade) => {
    if (validade.length !== 4) {
      return false;
    }
    const dateAtual = new Date(Date.now());
    const mesValidade = validade.substring(0, 2).replace('_', '');
    const anoValidade = '20' + validade.substring(2, 4).replace('_', '');
    const dateValidade = new Date(
      anoValidade,
      mesValidade - 1,
      dateAtual.getDate(),
      dateAtual.getHours(),
      dateAtual.getMinutes(),
      dateAtual.getSeconds(),
    );

    if (mesValidade > 12) return false;
    if (dateValidade.getMonth() == dateAtual.getMonth() && dateValidade.getFullYear() == dateAtual.getFullYear())
      return true;
    if (dateAtual > dateValidade) return false;

    return true;
  };

  const handleValidForm = async (form) => {
    if (!isCompleted) {
      toast.error('Informe o endereço de entrega');
      return;
    }
    showHideModalLoading();

    const objCartao = {
      cliente: {
        codigo: user.id,
        nome: user.nome,
        sobrenome: user.sobrenome,
        nomeCompleto: user.nome_completo,
        email: user.email,
        tipoDocumento: 'CPF',
        numeroDocumento: user.cpf,
        ddd: user.telefone_ddd,
        telefone: user.telefone,
      },
      endereco: {
        cep: enderecoFatura.cep,
        endereco: enderecoFatura.endereco,
        endereco_numero: enderecoFatura.endereco_numero,
        endereco_complemento: enderecoFatura.endereco_complemento,
        endereco_bairro: enderecoFatura.endereco_bairro,
        endereco_cidade: enderecoFatura.endereco_cidade,
        endereco_estado: enderecoFatura.endereco_cidade,
        endereco_pais: 'BRASIL',
        uf: enderecoFatura.endereco_estado,
      },
      cartao: {
        numeroCartao: removeMask(form.numeroCartao),
        nomeImpresso: form.nomeImpresso,
        mesExpiracao: form.validade.substring(0, 2),
        anoExpiracao: form.validade.substring(3, 8),
        codigoSeguranca: form.codigoSeguranca,
        cpf: form.cpf,
        tokenCard: '',
        salvar_cartao: form.salvar_cartao,
      },
      empresa: {
        idLoja: dadosApp.IdLoja,
        fantasia: dadosApp.Empresa.Empresa.fantasia,
        razaoSocial: dadosApp.Empresa.Empresa.razao,
      },
    };

    if (formDireto) {
      setDadosCartao((prevState) => {
        return {
          ...prevState,
          cartao_nome: '', // bandeira
          cartao_numero: objCartao.cartao.numeroCartao,
          nome_completo_cartao: objCartao.cartao.nomeImpresso,
          cartao_validade: form.validade, //objCartao.cartao.anoExpiracao + '-' + objCartao.cartao.mesExpiracao,
          cartao_codigo_seguranca: objCartao.cartao.codigoSeguranca,
          cpf: objCartao.cartao.cpf,
          tokenCard: objCartao.cartao.tokenCard,
          endereco: objCartao.endereco,
          salvar_cartao: objCartao.cartao.salvar_cartao,
        };
      });
      setModalLoading('none');
      setTimeout(() => {
        onClick(objCartao); // chama o método de finalização da view Finalizar
      }, 250);
    } else handleSaveCard(objCartao);
  };

  const handleSaveCard = async (objCartao) => {
    // SALVA O CARTÃO
    const resp = await SalvarCartao(objCartao);
    setModalLoading('none');

    if (resp.data.Retorno) {
      if (resp.data.Retorno.status === 1) {
        toast.error(resp.data.Retorno.msg.toString(), { containerId: 'modalToast' });
        return;
      }
    } else {
      if (resp.data.status === 'error') {
        toast.error(resp.data.retornoMensagem, { autoClose: 5000 });

        switch (resp.data.retornoMensagem) {
          case 'Por favor, atualize seu cadastro com nome completo antes de continuar.':
          case 'Nome do cliente inválido!':
          case 'Cpf inválido!':
            // abre o modal de cadastro
            setModalMeusDados(modalMeusDados === 'none' ? 'block' : 'none');
            break;

          default:
            break;
        }

        return;
      }
    }

    toast.success('Cadastrado com Sucesso');
    handleNewBack(true);
  };

  // const setSessionId = useCallback(() => {
  //   if (dadosApp.IdLoja > 0) {
  //     if (dadosApp.Empresa.Config.pagamento_online === 1 && dadosApp.Empresa.Config.cartao_operadora === 'PAGSEGURO') {
  //       window.PagSeguroDirectPayment.setSessionId(dadosApp.GuidSessao);
  //       window.PagSeguroDirectPayment.onSenderHashReady(function (response) {
  //         if (response) {
  //
  //           if (response.status == 'error') {
  //             return false;
  //           }

  //           if (dadosApp.sH !== response.senderHash) {
  //             setDadosApp((prevState) => {
  //               return {
  //                 ...prevState,
  //                 sH: response.senderHash,
  //               };
  //             });
  //           }
  //         }
  //       });
  //     }
  //   }
  // }, [dadosApp, setDadosApp]);

  return (
    <>
      <form
        onSubmit={handleSubmit(handleValidForm)}
        className="modal-content-dialog padTop20 cardShadow"
        style={{ border: '0px solid #fbfbfb', paddingTop: 30, paddingBottom: 10, marginBottom: 20 }}
      >
        <div className="form-container">
          <LabelForm text="Nome impresso no cartão" />
          <input
            type="text"
            placeholder=""
            className="form-control"
            {...register('nomeImpresso', {
              validate: (value) => value !== '',
            })}
          />
          {errors.nomeImpresso && <p className="form-errors">Informe o nome do titular</p>}
        </div>
        <div className="form-container">
          <LabelForm text="Número do Cartão" />
          <InputMask
            type="text"
            placeholder=""
            className="form-control"
            mask={creditCardMask}
            maskChar={null}
            {...register('numeroCartao', {
              validate: (value) => {
                const creditCard = removeMask(value);
                if (isAmex && creditCard.length != 15) return false;
                if (!isAmex && creditCard.length != 16) return false;
                return true;
              },
            })}
            onChange={handleInputs}
          />
          {errors.numeroCartao && <p className="form-errors">Cartão Inválido</p>}
        </div>

        <div className="form-group-col2">
          <div className="form-container">
            <LabelForm text="Validade" />
            <InputMask
              type="text"
              placeholder="mm/aa"
              className="form-control"
              mask="99/99"
              maskChar={'_'}
              {...register('validade', {
                validate: (value) => {
                  const validade = removeMask(value);
                  return handleValidade(validade);
                },
              })}
            />
            {errors.validade && <p className="form-errors">Validade Inválida</p>}
          </div>
          <div className="form-container">
            <LabelForm text="CVV" />
            <InputMask
              type="text"
              className="form-control"
              mask={isAmex ? '9999' : '999'}
              maskChar={null}
              {...register('codigoSeguranca', {
                validate: (value) => {
                  const cvv = removeMask(value);
                  if (isAmex && cvv.length != 4) return false;
                  if (!isAmex && cvv.length != 3) return false;
                  return true;
                },
              })}
            />
            {errors.codigoSeguranca && <p className="form-errors">CVV Inválido</p>}
          </div>

          <div className="form-container">
            <LabelForm text="CPF" />
            <input
              type="text"
              placeholder=""
              className="form-control"
              {...register('cpf', {
                validate: (value) => {
                  if (isNaN(value) || !ValidarCPF(value)) {
                    return false;
                  }
                },
              })}
            />
            {errors.cpf && <p className="form-errors">CPF Inválido</p>}
          </div>
        </div>

        <p style={{ fontWeight: 'bold', paddingTop: 10, color: '#60686f' }}>Endereço da Fatura</p>

        {/* <Button
          text={!isObjectEmpty(enderecoFatura) ? enderecoConcatenado() : 'Selecionar Endereço'}
          onClick={showHideModalEnderecos}
          icon={isObjectEmpty(enderecoFatura) ? 'keyboard_arrow_right' : ''}
          iconAlign="right"
          className="btnWhite btn-shadow"
        /> */}

        <div
          className="btnWhite btn-shadow-active"
          style={{ margin: '15px 0 30px 0', width: '100%', marginLeft: '0', height: '100%' }}
          onClick={showHideModalEnderecos}
        >
          <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
            keyboard_arrow_right
          </i>
          <div className="content-centered" style={{ color: isObjectEmpty(enderecoFatura) ? 'rgb(229,71,80)' : '' }}>
            <p>{!isObjectEmpty(enderecoFatura) ? enderecoConcatenado() : 'Selecionar Endereço'}</p>
          </div>
        </div>
        {/* <div
          className="btnWhite btn-shadow-active"
          style={{ margin: '15px 0 30px 0', width: '100%', marginLeft: '0' }}
          onClick={showHideModalEnderecos}
        >
          <i className="material-icons  btnIconAlignRight" style={{ marginTop: 15 }}>
            keyboard_arrow_right
          </i>
          <div className="content-centered" style={{ color: isObjectEmpty(enderecoFatura) ? 'rgb(229,71,80)' : '' }}>
            {!isObjectEmpty(enderecoFatura) ? enderecoConcatenado() : 'Selecionar Endereço'}
          </div>
        </div> */}

        <div className={'checkboxes float-left '}>
          <label className={'container-check'}>
            {'Salvar cartão para compras futuras'}
            <input
              type={'checkbox'}
              defaultChecked={true}
              //value={'val'}
              name={'name'}
              {...register('salvar_cartao')}
            />
            <span className={'checkmark'}></span>
          </label>
        </div>

        <div className="padTop20 padBottom20"></div>

        <div className="padTop20 padBottom20">
          {/* <Button
            type="submit"
            text="Salvar"
            textAlign="center"
            className={`btn_1 full-width btnFinalizar ${!isCompleted ? ' btnDisabled' : ''}`}
          /> */}

          {/* <Aviso type="warning" showBorderLeft showIcon /> */}

          <Button
            type={'submit'}
            className={`btn_1 full-width mb_5 btnPaymentGreen ${!isCompleted && !formDireto ? ' btnDisabled' : ''}`}
            text={`${formDireto ? 'Pagar' : 'Salvar'}`}
            textAlign={`${formDireto ? 'left' : 'center'}`}
            text2={`${formDireto ? FormataValor(valor) : ''}`}
            text2Align={`${formDireto ? 'right' : ''}`}
          />
        </div>
      </form>

      <GatewaysLogo />

      {modalEnderecos === 'block' && (
        <Modal
          title="Endereços"
          isFooter={false}
          visibility={modalEnderecos}
          param={{
            isFinalizacao: true,
            isFatura: true,
            setEnderecoEntrega: setEnderecoFatura,
            closeModal: showHideModalEnderecos,
          }}
          page="ENDERECOS"
          btnOnClickClose={showHideModalEnderecos}
        />
      )}
      {modalMeusDados === 'block' && (
        <Modal
          title="Meus Dados"
          isFooter={false}
          visibility={modalMeusDados}
          page="MEUS_DADOS"
          btnOnClickClose={showHideModalMeusDados}
        />
      )}
      {modalLoading === 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}
    </>
  );
};

CadastroCartoes.propTypes = {
  handleNewBack: P.func,
  onClick: P.func,
  setDadosCartao: P.func,
  isCompleted: P.bool,
  formDireto: P.bool,
  valor: P.oneOfType([P.string, P.number]),
};
